import { useState, type FormEvent } from 'react';
import DialogError from '@/shared/ui/DialogError';
import FormField from '@/shared/ui/FormField';
import { primaryButtonClass, secondaryButtonClass } from '@/shared/ui/formClasses';
import Modal, { ModalBody, ModalFooter, ModalForm } from '@/shared/ui/Modal';
import { passwordErrors, type PasswordErrors } from '../model/users';

type SetPasswordDialogProps = {
  target: { label: string; email: string };
  saving: boolean;
  error?: string;
  onSubmit: (password: string) => void;
  onClose: () => void;
};

/** `onSubmit(password)` salva una password già valida; `error` è il rifiuto del server, nel dialogo. */
export default function SetPasswordDialog({
  target,
  saving,
  error,
  onSubmit,
  onClose,
}: SetPasswordDialogProps) {
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [errors, setErrors] = useState<PasswordErrors>({});

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const found = passwordErrors(password, confirmation);
    setErrors(found);
    if (Object.keys(found).length === 0) onSubmit(password);
  };

  return (
    <Modal
      title="Imposta password"
      description={`Utente: ${target.label} · ${target.email}`}
      onClose={onClose}
      closeDisabled={saving}
    >
      <ModalForm noValidate onSubmit={handleSubmit}>
        <ModalBody>
          {error && <DialogError>{error}</DialogError>}
          <FormField
            id="pwd-new"
            label="Nuova password"
            type="password"
            autoComplete="new-password"
            autoFocus
            required
            value={password}
            onChange={(value) => {
              setPassword(value);
              setErrors({});
            }}
            error={errors.password}
          />
          <FormField
            id="pwd-confirm"
            label="Conferma password"
            type="password"
            autoComplete="new-password"
            required
            value={confirmation}
            onChange={(value) => {
              setConfirmation(value);
              setErrors({});
            }}
            error={errors.confirmation}
          />
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className={secondaryButtonClass}
          >
            Annulla
          </button>
          <button type="submit" disabled={saving} className={primaryButtonClass}>
            {saving ? 'Salvataggio…' : 'Salva password'}
          </button>
        </ModalFooter>
      </ModalForm>
    </Modal>
  );
}
